import { render } from "./VLInput.vue?vue&type=template&id=578dcd7d"
import script from "./VLInput.vue?vue&type=script&lang=js"
export * from "./VLInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/sources/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__